// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const mainPaneHeight = "calc(100vh - 64px)";
export const internalSidebar = "InternalSidebar__internalSidebar__wVQi0 font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const mainPane = "InternalSidebar__mainPane__Df+UW";
export const descended = "InternalSidebar__descended__hGzl3";
export const floating = "InternalSidebar__floating__bCTlt";
export const panesWrapper = "InternalSidebar__panesWrapper__etLb9";
export const descendingPane = "InternalSidebar__descendingPane__9niKv";
export const header = "InternalSidebar__header__frHjK";
export const notificationsTrayButton = "InternalSidebar__notificationsTrayButton__iRbwl";
export const notificationsTrayButtonWrapper = "InternalSidebar__notificationsTrayButtonWrapper__uF8WP";
export const logo = "InternalSidebar__logo__oy6a7";
export const buttons = "InternalSidebar__buttons__eijx4";
export const peergroupsButtonWrapper = "InternalSidebar__peergroupsButtonWrapper__AjIT8";
export const navigationButton = "InternalSidebar__navigationButton__qtMpF";
export const navigation = "InternalSidebar__navigation__cylHX";
export const menuButton = "InternalSidebar__menuButton__-yzaJ";
export const counterContainer = "InternalSidebar__counterContainer__xaWCm";